// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"T2-z","colorTextValue":"U2-z","swatches":"V2-z","collapseLink":"W2-z","isCollapsed":"X2-z","dropdown":"Y2-z","disabled":"Z2-z"};